<template>
  <el-form ref="form" :model="editFormData" label-width="120px" label-position="top">
    <el-form-item label="Navn" prop="name">
      <el-input v-model="editFormData.name" />
    </el-form-item>
    <el-form-item label="Oprindelse" prop="origin">
      <el-input v-model="editFormData.origin" />
    </el-form-item>
    <el-form-item label="Info" prop="description">
      <el-input v-model="editFormData.description" type="textarea" rows="5" />
    </el-form-item>
    <el-form-item label="Tags" prop="tags">
      <el-select
        v-model="editFormData.tags"
        multiple
        filterable
        allow-create
        default-first-option
        style="width: 100%">
        <el-option
          v-for="tag in $store.getters.tags"
          :key="tag"
          :label="tag"
          :value="tag" />
      </el-select>
    </el-form-item>
    <el-form-item label="Dato for første smagning" prop="date">
      <el-date-picker
        v-model="editFormData.date"
        type="date"
        placeholder="Vælg en dato" />
    </el-form-item>
    <el-form-item label="Billede" prop="image">
      <el-upload
        :show-file-list="false"
        class="image-upload"
        action="https://jsonplaceholder.typicode.com/posts/">
        <img v-if="editFormData.image" :src="`/static/${editFormData.image}`">
        <i v-else class="el-icon-plus image-upload-icon" />
      </el-upload>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      editFormData: JSON.parse(JSON.stringify(this.data)),
    }
  },

  methods: {
    getData() {
      return this.editFormData
    }
  }
}
</script>

<style>
.image-upload .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.image-upload .el-upload:hover {
  border-color: #409EFF;
}

.image-upload img {
  display: block;
  width: 200px;
  height: 200px;
  object-fit: cover;
}
.image-upload-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCheeseForm.vue